module.exports = __webpack_public_path__ + "static/img/manual_zh_32.5d7c787.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_32.png
// module id = yOMl
// module chunks = 4